import { mdiInformationOutline } from '@mdi/js'
import Icon from '@mdi/react'

const FONT_SIZES = {
    small: '20px',
    medium: '24px',
    large: '35px',
    inherit: '1em',
}

interface InfoProps {
    color?: string
    fontSize?: 'small' | 'medium' | 'large' | 'inherit'
}

const Info = ({ color, fontSize = 'small' }: InfoProps) => (
    <Icon
        data-testid="Tooltip__PopupIcon"
        path={mdiInformationOutline}
        size={FONT_SIZES[fontSize]}
        color={color}
    />
)

export default Info
